import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type = 'website', title, description, url, image }) => {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": type === 'website' ? "WebSite" : "SoftwareApplication",
        "name": title || "PrepWize",
        "description": description || "AI-powered calorie tracker",
        "url": url || "https://prepwize.ai",
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://prepwize.ai/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
        }
    };

    if (type === 'app') {
        structuredData.applicationCategory = "HealthApplication";
        structuredData.operatingSystem = "Web Browser";
        structuredData.offers = {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
        };
    }

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
};

export default StructuredData; 